<template>
    <div class="log-list">
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <!--<el-form-item>-->
            <!--<el-input v-model="search" placeholder="输入模块名查询" size="small"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="举报时间从">
                <el-date-picker v-model="search.startTime" type="datetime" placeholder="开始时间" align="center">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="search.endTime" type="datetime" placeholder="结束时间" align="center">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="举报原因">
                <el-select v-model="search.module" placeholder="选择举报原因">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="职位造假" value="1"></el-option>
                    <el-option label="职位过期" value="2"></el-option>
                    <el-option label="职位描述不符" value="3"></el-option>
                    <el-option label="职位无法联系到招聘方" value="4"></el-option>
                    <el-option label="职位包含违法信息" value="5"></el-option>
                    <el-option label="简历造假" value="6"></el-option>
                    <el-option label="简历描述不全" value="7"></el-option>
                    <el-option label="简历无法联系到候选人" value="8"></el-option>
                    <el-option label="简历包含违法信息" value="9"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="举报类型">
                <el-select v-model="search.optType" placeholder="选择举报类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="职位举报" value="1"></el-option>
                    <el-option label="简历举报" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="fetch" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column prop="id" label="举报编号"></el-table-column>
            <el-table-column prop="type" label="举报类型">
                <template slot-scope="scope">{{typeMap[scope.row.type]}}</template>
            </el-table-column>
            <el-table-column prop="reportedUserName" label="被举报用户昵称"></el-table-column>
            <el-table-column prop="content" label="被举报内容">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">{{scope.row.content}}</span>
                    <span v-else>{{scope.row.reportedUserName}}的简历</span>
                </template>
            </el-table-column>
            <el-table-column prop="reason" label="举报原因">
            </el-table-column>
            <el-table-column prop="userName" label="举报用户昵称"></el-table-column>
            <el-table-column prop="createTime" label="举报时间"></el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
          <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="i=>page=i"
                  :page-size="limit"
                  :page-count="page"
                  :total="total">
          </el-pagination>
        </div>
    </div>
</template>
<script>
import api from '../api'
const {
    reportLog
} = api



export default {
    name: "report-list",
    data() {
        return {
            loading: true,
            list: [],
            roles: [],
            total: 0,
            limit: 20,
            page: 1,
            search: {
                module: '',
                optType: '',
                startTime: '',
                endTime: ''
            },
            reasonMap: {
                1: '职位造假',
                2: '职位过期',
                3: '职位描述不符',
                4: '职位无法联系到招聘方',
                5: '职位包含违法信息',
                6: '简历造假',
                7: '简历描述不全',
                8: '简历无法联系到候选人',
                9: '简历包含违法信息',
            },
            typeMap: {
                1: '职位举报',
                2: '简历举报',
            },
        };
    },
    watch: {
        page() {
            this.fetch()
        }
    },
    methods: {
        async fetch() {
            this.loading = true;

            let pageNum = this.page
            let {
                module,
                optType,
                startTime,
                endTime
            } = this.search
            let obj = {
                pageNum: pageNum,
                limit: this.limit,
                module,
                optType,
                startTime,
                endTime
            }
            if (startTime && endTime) {
                obj.startTime = Date.parse(obj.startTime)
                obj.endTime = Date.parse(obj.endTime)
            }
            if (startTime && !endTime) {
                obj.endTime = Date.now()
                obj.startTime = Date.parse(obj.startTime)
            }
            let res = await reportLog.list(obj);

            this.total = res.data.pageinfo.totalCount
            this.list = res.data.data;
            this.loading = false;
        },
    },
    mounted() {
        this.fetch();
    }
};
</script>
<style>
.user-list {}
</style>


// WEBPACK FOOTER //
// src/views/log/report-list.vue